// 1/5" cutting loss per piece when splicing rails.
const CUTTING_LOSS_PER_PIECE_MM = 5.08

/**
 * Total rail pieces and splice count for UltraRail rows.
 * Rail pieces per row = ceil(row length / rail length); splicing reuses excess from first line.
 */
export function computeTotalRailsAndSplices(
  railLengthMm: number,
  railRun: number,
  rowLengthsMm: number[]
): { totalPieces: number; totalSplices: number } {
  let totalPieces = 0
  let totalSplices = 0

  for (const rowLengthMm of rowLengthsMm) {
    const piecesForFirstRailLine = Math.ceil(rowLengthMm / railLengthMm)
    totalSplices += railRun * (piecesForFirstRailLine - 1)

    if (railRun === 1) {
      totalPieces += piecesForFirstRailLine
      continue
    }

    const firstRailLineLength = piecesForFirstRailLine * railLengthMm
    const excessRailLength = firstRailLineLength - rowLengthMm
    const lastPieceLength = railLengthMm - excessRailLength
    const reusableExcessRails = Math.floor(excessRailLength / (lastPieceLength + CUTTING_LOSS_PER_PIECE_MM))

    if (reusableExcessRails > 0) {
      const otherRailLines = railRun - 1
      const additionalPieces = Math.max(0, otherRailLines - reusableExcessRails)
      const piecesForOtherRailLines = otherRailLines * (piecesForFirstRailLine - 1)
      const finalPieces = piecesForFirstRailLine + piecesForOtherRailLines + additionalPieces
      totalPieces += finalPieces
    } else {
      totalPieces += railRun * piecesForFirstRailLine
    }
  }
  return { totalPieces, totalSplices }
}
